import {
  LogoContainer,
  MatchTeamContainer,
  SourceTitle,
  DisplayName,
  TeamScore,
  TeamScoreContainer,
  DisplayNameContainer,
} from "./styles";
import { selectRosterDisplayNameOrPlaceholder } from "selectors/Roster";
import { ShuffleBracketSource } from "model/Bracket/ShuffleBracketGraph";
import { positionNumberToText } from "Utility";
import { matchHasStarted } from "model/Match/MatchStatus";
import {
  Match,
  getWinningRosterIds,
  matchCompleteByByesOrForfeits,
} from "model/Match/Match";
import { getRosterId, Roster } from "model/Roster/Roster";
import { getRosterDisplayScore } from "model/Match/MatchScore";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { JSX } from "react";
import { useAppSelector } from "app/hooks";

interface Props {
  match: Match;
  roster: Roster | undefined;
  tournamentId: string;
  source: ShuffleBracketSource;
}

export const ShuffleBracketMatchTeam = ({
  match,
  roster,
  tournamentId,
  source,
}: Props) => {
  const rosterId = !!roster ? getRosterId(roster) : undefined;

  const displayName = useAppSelector((state) =>
    !!roster
      ? selectRosterDisplayNameOrPlaceholder(state, roster, tournamentId)
      : undefined
  );

  const scoreString = !!rosterId
    ? getRosterDisplayScore(match, rosterId)
    : undefined;
  const matchWinnerIds = getWinningRosterIds(match);
  const hasWinner = !!matchWinnerIds;
  const isWinner = !!rosterId && hasWinner && matchWinnerIds.includes(rosterId);

  var nameJsx: JSX.Element | undefined;
  if (!!displayName && displayName !== "TBD") {
    nameJsx = (
      <DisplayName hasWinner={hasWinner} isWinner={isWinner}>
        {displayName}
      </DisplayName>
    );
  } else if (!!source.node?.matchTitle) {
    nameJsx = (
      <SourceTitle>{`${source.node?.matchTitle} ${positionNumberToText(
        source.position
      )}`}</SourceTitle>
    );
  } else {
    nameJsx = <SourceTitle>{source.source}</SourceTitle>;
  }

  return (
    <MatchTeamContainer key={rosterId}>
      <LogoContainer>
        {!!rosterId && (
          <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
        )}
      </LogoContainer>
      <DisplayNameContainer>{nameJsx}</DisplayNameContainer>
      {(matchHasStarted(match) ||
        matchCompleteByByesOrForfeits(match.teams.rosters)) && (
        <TeamScoreContainer>
          <TeamScore hasWinner={hasWinner} isWinner={isWinner}>
            {scoreString}
          </TeamScore>
        </TeamScoreContainer>
      )}
    </MatchTeamContainer>
  );
};
